
import { Pipe, PipeTransform, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
@Pipe({
  name: 'urlParams'
})
export class UrlParamsPipe implements PipeTransform {
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {}
  transform(urlValue: string, queryParams: { [key: string]: any }): string {
    // Handle null or undefined values
    if (!urlValue) {
      return '';
    }
    
    let value = urlValue.toString().toLowerCase();
    if(!value.endsWith('/')){
      value += '/';
    }
    if (queryParams == null || Object.keys(queryParams).length === 0) {
      if (isPlatformBrowser(this.platformId)) {
        const externalQueryParams = sessionStorage.getItem('external_queryParams');
        if(externalQueryParams === null){
          return value;
        }else{
          const obj = JSON.parse(externalQueryParams);
          const paramsArray: string[] = [];
          for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
              paramsArray.push(`${key}=${obj[key]}`);
            }
          }
          const paramsString = paramsArray.length > 0 ? `?${paramsArray.join('&')}` : '';
          return `${value}${paramsString}`;
        }
      } else {
        return value;
      }
    }else{
      const paramsArray: string[] = [];
      for (const key in queryParams) {
        if (queryParams.hasOwnProperty(key)) {
          paramsArray.push(`${key}=${queryParams[key]}`);
        }
      }
      const paramsString = paramsArray.length > 0 ? `?${paramsArray.join('&')}` : '';
      return `${value}${paramsString}`;
    }
  }
}